module.exports = __webpack_public_path__ + "static/img/icon_zanwuwbmdpx@2x.104a368c.png";